var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconClockCircleFillComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-clock_circle_fill").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.00004 15.335C12.051 15.335 15.335 12.051 15.335 8.00004C15.335 3.94903 12.051 0.665039 8.00004 0.665039C3.94903 0.665039 0.665039 3.94903 0.665039 8.00004C0.665039 12.051 3.94903 15.335 8.00004 15.335ZM7.15735 4.40276V8.07809C7.15735 8.31214 7.27432 8.53071 7.46906 8.66053L10.6563 10.7854C10.7482 10.8466 10.8724 10.8218 10.9337 10.7299L11.4884 9.89784C11.5497 9.80594 11.5248 9.68176 11.4329 9.62049L8.55735 7.70346V4.40276C8.55735 4.2923 8.46781 4.20276 8.35735 4.20276H7.35735C7.24689 4.20276 7.15735 4.2923 7.15735 4.40276Z", fillOpacity: "1" }));
}
var IconClockCircleFill = React.forwardRef(IconClockCircleFillComponent);
export default IconClockCircleFill;
